import templateUrl from './system-metrics.html';

export default {
  templateUrl,
  controller: class SystemMetricsComponent {
    constructor($scope, LoadingService, SystemMetricsService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        LoadingService,
        SystemMetricsService,
        ToastService
      });
    }

    $onInit() {
      this.chartConfig = {
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: 'System Metric Report'
        },
        subtitle: {
          text: 'NASC Adverse Event Reporting System'
        },
        xAxis: {
          type: 'datetime',
          title: {
            style: {
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              fontSize: '14px'
            }
          },
          tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
        },
        yAxis: [{
          title: {
            text: 'Administrations (mil)',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: window.Highcharts.getOptions().colors[1],
              fontSize: '14px'
            }
          }
        }, {
          title: {
            text: 'Count',
            style: {
              color: window.Highcharts.getOptions().colors[0],
              fontSize: '14px'
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: window.Highcharts.getOptions().colors[0],
              fontSize: '14px'
            }
          },
          opposite: true
        }],
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:,.2f} </b></td></tr>',
          footerFormat: '</table>',
          split: true,
          useHTML: true
        },
        legend: {
          itemStyle: {
            fontSize: '14px'
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          },
          area: {
            fillOpacity: 0.2,
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              enabled: false
            }
          },
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1
            }
          }
        }
      };
    }

    generateReport({ params }) {
      this.LoadingService.start();
      this.SystemMetricsService.getReport(params)
        .then((series) => {
          this.chartConfig.series = series;
        }).catch(error => this.ToastService.showError(error))
      .finally(() => {
        this.LoadingService.stop();
        this.$scope.$apply();
      });
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/system-metrics/system-metrics.component.js